import { useQuery } from "@tanstack/react-query"

import { useApiContext } from "@/hooks/api/use-api-context"

import { fetchAutomationTriggerButtons } from "./api"

export function useFetchAutomationTriggerButtons(
  recordType?: string,
  recordId?: string,
  options?: { enabled?: boolean }
) {
  const getContext = useApiContext()
  return useQuery({
    queryKey: ["automation-trigger-buttons", recordType, recordId],
    queryFn: async () => {
      const context = await getContext()
      if (!context) throw new Error("No context found")
      return fetchAutomationTriggerButtons(context, recordType, recordId)
    },
    enabled: options?.enabled ?? true,
    retry: false,
  })
}
